/**
 * プログレスバーコンポーネント
 */
export default {
    template: '#progress_bar_component_template',
    props: {
        // 達成フラグリスト
        tasks: {
            type: Object,
            default: () => ({}),
            require: true
        },
    },
    computed: {
        // プログレスバー数値
        progressWidth: function () {
            let doneCount = 0;
            const length = Object.keys(this.tasks).length;
            if (!length) {
                return doneCount;
            }
            for (const key in this.tasks) {
                if (this.tasks[key]) {
                    doneCount++;
                }
            }
            return Math.floor(doneCount / length * 100);
        }
    }
};
